const externalLinkTypes = {
  HEADER: 1,
  FOOTER: 2
};

export {
  // eslint-disable-next-line import/prefer-default-export
  externalLinkTypes
};
